import React from 'react';
import Spinner from '../generics/Spinner';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';


const FilterYieldModal = (props) => {
        let avgStyle = {}
        if (props.item){
          avgStyle = {
            color: props.item.main_product_yield <= props.avgYield.value ? '#058505' : '#8f0202',
          }
        }
        return(
          <Modal isOpen={props.isOpen} toggle={props.closeModal} className={'modal-primary modal-logut'}>
            <ModalHeader toggle={props.closeModal} >Filter average yield</ModalHeader>
            <ModalBody>
              <div className="row mb-1">
                <div className="col-6">
                  <label className="col-form-label filter-label" htmlFor="select"><i className="fa fa-calendar-o mr-05 ml-05"></i>From Date</label>
                  <input type="date" id="date" className='form-control' value={props.fromDate} onChange={(date) => props.onFromDateChange(date)}/>
                </div>
                <div className="col-6">
                  <label className="col-form-label filter-label" htmlFor="select"><i className="fa fa-calendar-o mr-05 ml-05"></i>To Date</label>
                  <input type="date" id="date" className='form-control' value={props.toDate} onChange={(date) => props.onToDateChange(date)}/>
                </div>
              </div>
              {props.avgYield.loading && <Spinner /> }
              {props.avgYield.error &&
                <div className="row mb-1">
                  <div className="col-12 mb-q">
                    <strong>There has been an error, please try again later</strong>
                  </div>
                </div>
              }
              {!props.avgYield.loading && !props.avgYield.error&&
                <div className="row mb-1">
                  <div className="col-12 mb-q">
                    <strong>Session Id:</strong> <span>{props.item.session}</span>
                  </div>
                  <div className="col-12 mb-q">
                    <strong>Main product Yield:</strong> <span>{props.item.main_product_yield} %</span>
                  </div>
                  <div className="col-12 mb-q" style={avgStyle}>
                    <strong>Average Yield:</strong> <span>{props.avgYield.value} %</span>
                  </div>
                </div>
              }
            </ModalBody>
          </Modal>
        )
}

export default FilterYieldModal
